import React, { useEffect, useState } from 'react';
import { loadGoogleMaps } from '../utils/loadGoogleMaps'; // Ensure this path is correct
import Sidebar from './sidebar';
import Header from './header';
import { useNavigate } from 'react-router-dom';

const OrganizationLocation = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate(); // useNavigate hook for navigation

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await fetch('https://ward3-chandrapur-api.palikaapp.com/api/organization/all'); // Use your API URL
        const data = await response.json();
        setOrganizations(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  useEffect(() => {
    const initMap = async () => {
      try {
        const googleMaps = await loadGoogleMaps("AIzaSyB4Z418MHwoKYfrN9wq28zZvgqtfwmNXa4"); // Replace with your actual API key

        const firstOrganization = organizations[0];
        const mapCenter = firstOrganization
          ? { lat: parseFloat(firstOrganization.latitude), lng: parseFloat(firstOrganization.longitude) }
          : { lat: 27.7000, lng: 85.3000 }; // Fallback if no organizations

        const map = new googleMaps.Map(document.getElementById("map"), {
          zoom: 12,
          center: mapCenter,
          mapTypeId: "terrain",
        });

        if (window.existingMarkers) {
          window.existingMarkers.forEach(marker => marker.setMap(null));
        }

        window.existingMarkers = [];

        organizations.forEach(org => {
          const marker = new googleMaps.Marker({
            position: { lat: parseFloat(org.latitude), lng: parseFloat(org.longitude) },
            map: map,
            icon: {
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
            },
            title: org.name,
          });

          window.existingMarkers.push(marker);

          const infowindow = new googleMaps.InfoWindow({
            content: `<div style="font-weight: bold; color: #000;">
                        ID: ${org.id}<br/>
                        Name: ${org.name}<br/>
                        Organization Type: ${org.orgType}<br/>
                        Owner: ${org.ownerName}, Email: ${org.ownerEmail}
                      </div>`,
          });

          marker.addListener('mouseover', () => {
            infowindow.open(map, marker);
            marker.setIcon({
              url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            });
          });

          marker.addListener('mouseout', () => {
            infowindow.close();
            marker.setIcon({
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
            });
          });

          // Use navigate for redirection
          marker.addListener('click', () => {
            navigate(`/organization/${org.id}/details`);
          });
        });
      } catch (error) {
        console.error("Failed to load Google Maps:", error);
      }
    };

    if (organizations.length > 0) {
      initMap();
    }
  }, [organizations, navigate]); // Add navigate to the dependencies

  const containerStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    maxWidth: '1200px',
    margin: '90px auto',
    marginTop: '80px',
    marginLeft: '250px',
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <Sidebar />
      <Header />
      <div style={containerStyle}>
        <h1>संस्थाहरुको स्थान</h1>
        <div id="map" style={{
          height: '600px',
          width: '100%',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        }}></div>
      </div>
    </div>
  );
};

export default OrganizationLocation;
